import { render, staticRenderFns } from "./DateRegis.vue?vue&type=template&id=4ae839b0&scoped=true"
import script from "./DateRegis.vue?vue&type=script&lang=js"
export * from "./DateRegis.vue?vue&type=script&lang=js"
import style0 from "./DateRegis.vue?vue&type=style&index=0&id=4ae839b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae839b0",
  null
  
)

export default component.exports